import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import { Grid, TextField, Toolbar } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { customTheme } from '../../../../../../styles/theme';

const useStyles = makeStyles({
  paper: {
    marginBottom: '20px',
    padding: '20px',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
  },
  toolbar: {
    width: '100%',
    padding: 0,
  },
  title: {
    flexGrow: 1,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: customTheme.spacing(1),
  },
});

interface BusinessObjectInfoCardComponentProps {
  businessObject: BusinessObject;
}

export default function BusinessObjectInfoCardComponent(props: BusinessObjectInfoCardComponentProps) {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <Toolbar className={classes.toolbar}>
        <Typography variant="h6" className={classes.title}>
          Business object
        </Typography>
      </Toolbar>

      <form className={classes.form}>
        <Grid container spacing={3}>
          <Grid item xs={3}>
            <TextField
              variant="outlined"
              margin="dense"
              type="number"
              fullWidth
              key="id"
              id="id"
              label="ID"
              name="id"
              value={props?.businessObject?.id || ''}
              disabled={true}
            />
          </Grid>

          <Grid item xs={9}>
            <TextField
              variant="outlined"
              margin="dense"
              type="email"
              required
              fullWidth
              key="name"
              id="name"
              label="Name"
              name="name"
              value={props?.businessObject?.name || ''}
              disabled={true}
            />
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}
